package com.dotdrives.web.pages.settings

import com.dotdrives.controller.SettingsController
import com.dotdrives.controller.SettingsUiState
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.useEffect
import react.useState
import web.cssom.ClassName
import web.dom.ElementId
import web.html.InputType
import web.html.number

external interface FiscalPeriodPanelProps : Props { var controller: SettingsController; var state: SettingsUiState; var canWrite: Boolean }

val FiscalPeriodPanel = FC<FiscalPeriodPanelProps> { props ->
    val (month, setMonth) = useState(props.state.fiscalStartMonth?.toString().orEmpty())
    val (day, setDay) = useState(props.state.fiscalStartDay?.toString().orEmpty())
    useEffect(props.state.fiscalStartMonth, props.state.fiscalStartDay) {
        setMonth(props.state.fiscalStartMonth?.toString().orEmpty()); setDay(props.state.fiscalStartDay?.toString().orEmpty())
    }
    div {
        className = ClassName("settings-section-card")
        div { className = ClassName("settings-section-title"); +"Fiscal year" }
        div { className = ClassName("settings-section-subtitle"); +"Reports and yearly goals use this start date. New organizations start on January 1." }
        props.state.fiscalError?.let { DotBanner { message = it; onRetry = props.controller::loadFiscalPeriod } }
        if (props.state.fiscalLoading) div { className = ClassName("settings-section-subtitle"); +"Loading fiscal year start…" }
        props.state.fiscalFeedback?.let { div { role = "status".unsafeCast<react.dom.aria.AriaRole>(); className = ClassName("settings-saved"); +it } }
        div {
            className = ClassName("settings-form-grid settings-fiscal-grid")
            label { +"Start month"; input { id = ElementId("fiscal-month"); type = InputType.number; min = 1.0; max = 12.0; value = month; disabled = !props.canWrite || props.state.fiscalSaving; onChange = { setMonth(it.currentTarget.value) } } }
            label { +"Start day"; input { id = ElementId("fiscal-day"); type = InputType.number; min = 1.0; max = 28.0; value = day; disabled = !props.canWrite || props.state.fiscalSaving; onChange = { setDay(it.currentTarget.value) } } }
        }
        if (props.canWrite) DotButton { text = "Save fiscal year"; loading = props.state.fiscalSaving; enabled = !props.state.fiscalLoading && props.state.fiscalStartMonth != null && month.toIntOrNull() in 1..12 && day.toIntOrNull() in 1..28; onClick = { props.controller.saveFiscalPeriod(month.toIntOrNull() ?: 0, day.toIntOrNull() ?: 0) } }
    }
}
